/**
 * Farbschema: folgt der Systemeinstellung, manuelle Übersteuerung bleibt in
 * localStorage (DESIGN.md, Abschnitt Farbe).
 */
const SCHLUESSEL = 'karteikarten:schema'
const ERLAUBT = new Set(['system', 'hell', 'dunkel'])

export function schemaLesen() {
  const wert = localStorage.getItem(SCHLUESSEL)
  return ERLAUBT.has(wert) ? wert : 'system'
}

export function schemaAnwenden(schema) {
  const wurzel = document.documentElement
  if (schema === 'system') delete wurzel.dataset.schema
  else wurzel.dataset.schema = schema
}

export function schemaSetzen(schema) {
  const sauber = ERLAUBT.has(schema) ? schema : 'system'
  if (sauber === 'system') localStorage.removeItem(SCHLUESSEL)
  else localStorage.setItem(SCHLUESSEL, sauber)
  schemaAnwenden(sauber)
  return sauber
}
